if (!customElements.get('lotus-variant-modal')) {
  class LotusVariantModal extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('[role="dialog"]');
      this.closeButton = this.querySelector('[data-modal-close]');
      this.closeButton?.addEventListener('click', () => this.hide());
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
      this.addEventListener('keyup', (event) => {
        if (event.code.toUpperCase() === 'ESCAPE') this.hide();
      });

      const select = this.querySelector('[data-variant-select]');
      select?.addEventListener('change', () => {
        const price = select.selectedOptions[0]?.dataset.price;
        const priceTarget = this.querySelector('[data-variant-price]');
        if (price && priceTarget) priceTarget.textContent = price;
      });
    }

    show(opener) {
      this.openedBy = opener;
      this.setAttribute('open', '');
      document.body.classList.add('overflow-hidden');
      if (typeof trapFocus === 'function' && this.dialog) {
        trapFocus(this, this.querySelector('[data-variant-select]') || this.dialog);
      }
    }

    hide(preventFocus = false) {
      if (!this.hasAttribute('open')) return;

      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && this.openedBy) cartDrawer.setActiveElement(this.openedBy);

      this.removeAttribute('open');
      if (typeof removeTrapFocus === 'function') removeTrapFocus(preventFocus ? null : this.openedBy);

      if (!document.querySelector('quick-add-modal[open], lotus-variant-modal[open], modal-dialog[open], cart-drawer.active')) {
        document.body.classList.remove('overflow-hidden');
      }

      document.body.dispatchEvent(new CustomEvent('modalClosed'));
      this.remove();
    }
  }

  customElements.define('lotus-variant-modal', LotusVariantModal);
}

if (!customElements.get('lotus-variant-picker')) {
  customElements.define('lotus-variant-picker', class LotusVariantPicker extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      this.template = this.querySelector('template');
      this.button?.addEventListener('click', () => this.open());
    }

    open() {
      if (!this.template || !this.button) return;

      document.querySelector('body > lotus-variant-modal')?.hide(true);

      const modal = document.createElement('lotus-variant-modal');
      modal.className = 'lf-variant-modal';
      modal.innerHTML = this.template.innerHTML;
      document.body.appendChild(modal);
      modal.show(this.button);
    }
  });
}
